import styled from 'styled-components';
import ziLoader from 'assets/black-loader-transperent.gif';
import { FlexContainer } from 'common/styles';
import { InsentCardBody, InsentCardHeader } from 'ui/components/Cards';

export const ChatDropdownText = styled.div`
  margin-right: 4px;
`;

export const FilterActiveDot = styled.div`
  margin-left: 7px;
  margin-bottom: -4px;
  background-color: red;
  width: 7px;
  height: 7px;
  border-radius: 50%;
`;

export const LoaderContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -35%);
  width: 100%;
  height: 100%;

  .zoomloader {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;

    .zoomloaderImg {
      background: url(${ziLoader}) no-repeat center center;
      background-size: contain;
      margin: auto;
      max-width: 100px;
      max-height: 100px;
      height: 100%;
      width: 100%;
    }
  }
`;

export const LatestMessagesPopupWrapper = styled.div`
  position: absolute;
  left: 50%;
  margin-bottom: 15px;
`;

export const LatestMessagesPopup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  left: -50%;
  width: 151px;
  height: 26px;
  background-color: #417dff;
  border: 1px solid #417dff;
  box-shadow: 0px 10px 13px rgba(159, 159, 159, 0.218531);
  border-radius: 10px;
  padding: 6px 18px;
  z-index: 10;
  cursor: pointer;
`;

export const LatestMessagesPopupText = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: ${p => p.theme.palette.white};
  white-space: nowrap;
  mix-blend-mode: normal;
`;

export const ArrowDownIconWrapper = styled.p`
  font-weight: bold;
  color: ${p => p.theme.palette.white};
  margin: 0;
`;

export const DetailContainer = styled(InsentCardBody)`
  height: ${p => (p.isEditAble ? 'calc(100% - 235px)' : 'calc(100% - 110px)')};
  position: absolute;
  width: 100%;
`;

export const ConversationDetailListInfiniteScroll = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem 1rem 0rem;
  overflow-x: hidden;
  overflow-y: scroll;
`;

export const AgentActionListWrapper = styled.div`
  height: 219px;
  max-height: 219px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const AgentProfileWrapper = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${p => p.theme.palette.lightBlue};

  img {
    height: 16px;
    cursor: pointer;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;

    &:active,
    &:focus {
      outline: none;
    }
  }
`;

export const AgentProfileLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const AgentProfileHeader = styled.p`
  margin: 0;
  margin-left: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${p => p.theme.palette.text.three};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
`;

export const AgentProfileDescription = styled.p`
  margin: 0;
  margin-left: 8px;
  font-size: 12px;
  opacity: 0.5;
  color: ${p => p.theme.palette.text.three};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
`;

export const AgentSearchForm = styled.form`
  position: relative;

  button {
    position: absolute;
    top: 50%;
    right: 2px;
    transform: translateY(-50%);
    padding: 0;
    border: none;
    background: white;
    opacity: 0.6;

    &:focus,
    &:active {
      outline: none;
    }
  }
`;

export const AgentActionWrapper = styled.div`
  padding: 17px 14px 17px 19px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${p => p.theme.palette.lightBlue};
`;

export const AgentActionHeader = styled.p`
  color: ${p => p.theme.palette.text.three};
  opacity: 0.8;
  font-size: 12px;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;

export const AgentActionDescription = styled.div`
  color: ${p => p.theme.palette.text.three};
  opacity: 0.5;
  font-size: 10px;
  margin: 0;
  padding: 0;
`;

export const StatusArrowIcon = styled.div`
  height: 24px;
  transform: rotate(${p => (p.rotate ? 180 : 0)}deg);
`;

export const StatusIndicator = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 20px;
  background: ${p => p.color || p.theme.palette.primary};
  display: inline-block;
  margin-right: 4px;
`;

export const StatusButton = styled.button`
  background: #ffffff;
  border: 1px solid #becff6;
  border-radius: 30px;
  padding: 3px 8px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-width: ${p => (p.isEditAble ? '105px' : '90px')};
  max-width: 105px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: ${p => p.theme.palette.text.nine};
  height: 30px;
  margin-left: 10px;
  &:active,
  &:focus {
    outline: none;
  }

  div {
    display: flex;
    align-items: center;
  }
`;

export const StatusText = styled.p`
  color: #0061ff;
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  line-height: 20px;
`;

export const StatusPopupWrapper = styled.div`
  width: 153px;
  background: #ffffff;
  border: 1px solid #dbdee3;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 8px 0;
  &:focus {
    outline: none;
  }
`;

export const StatusPopupItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: ${p => (p.isSelected ? '#edeff1' : '#fff')};
  &:hover {
    background: #edeff1;
    cursor: pointer;
  }
  & > span {
    font-size: 12px;
    line-height: 20px;
    color: #404040;
  }
  & > svg {
    margin-left: auto;
  }
`;

export const ProfilePopupContainer = styled.div`
  background: linear-gradient(
    180deg,
    ${p => p.theme.palette.border.eight} 0%,
    ${p => p.theme.palette.white} 100%
  );
  border-radius: 10px;
  box-shadow: 0px 10px 20px rgba(53, 59, 71, 0.0709135);
  &:focus {
    outline: none;
  }
  &:after {
    content: '';
    position: absolute;
    top: -15px;
    left: 5rem;
    width: 0;
    height: 0;
    border: 15px solid transparent;
    border-right-color: ${p => p.theme.palette.border.eight};
    border-left: 0;
    transform: rotate(90deg);
  }
  max-width: 220px;
  min-width: 220px;
  border-radius: 8px;
  max-height: 336px;
  min-height: 336px;
`;

export const ChatHeadAvatarWrapper = styled.span`
  cursor: pointer;
  padding: 2px;
  border: 1px solid #dbdee3;
  border-radius: 6px;
  height: 50px;
  width: 50px;
  ${p =>
    !p.hasImage &&
    `
  span[role="img"] {
    height: 30px !important;
    width: 30px !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }`}
  span[role="img"] {
    background-size: contain !important;
  }
`;

export const DetailSubHeaderText = styled.p`
  font-size: 14px;
  opacity: 0.8;
  color: #404040;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const DetailHeaderText = styled.p`
  font-weight: 500;
  font-size: 18px;
  color: #404040;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const DetailInfoText = styled.p`
  font-size: 12px;
  color: #6d7d8f;
  font-weight: 500;
  width: 100%;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  margin-left: 3px;
`;

export const DetailInfoContainer = styled.div`
  & > svg {
    width: 12px;
    height: 12px;
  }
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const ChatCardHeader = styled(InsentCardHeader)`
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding: 24px 24px 22px 24px !important;
  height: 105px;
  border-bottom: 1px solid ${p => p.theme.palette.lightBlue};
  overflow: hidden;
  position: relative;
`;

export const AddAgentAction = styled.span`
  background: white;
  border: 3px solid ${p => p.theme.palette.white};
  margin-left: 8px;
  border-radius: 50px;
  z-index: 5;
  height: 35px;
`;

export const StarChatButton = styled.button`
  border: 1px solid ${p => p.theme.palette.icon.inactive};
  background: white;
  border-radius: 50px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active,
  &:focus {
    outline: none;
  }
`;

export const VisitorDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: 100%;
  margin-left: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailHeader = styled.div`
  max-height: 64px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailBody = styled.div`
  /* height: ${p => (p.isEditAble ? '100%' : 'calc(100vh - 320px)')}; */
  flex-direction: column-reverse;
  overflow: auto;
  overflow-x: hidden;
  word-break: break-word;
  padding: ${p => (p.isEditAble ? '0 0 1rem' : '0')};
  height: 100%;
`;

export const ParticipantWrapper = styled.span`
  align-items: center;
  display: flex;
  position: relative;
  cursor: pointer;
  margin-top: -3px;
`;

export const AddAgentWrapper = styled.div`
  position: relative;
  border-radius: 50%;
  margin-left: ${p => p.marginLeft || '0'};
  margin-right: ${p => p.marginRight || '0'};
  z-index: ${p => p.zIndex || '1'};
  border: 3px solid ${p => p.theme.palette.white};
  height: 36px;
  overflow: hidden;
`;

export const RatingWrapper = styled.div`
  float: right;
  width: 300px;
  height: 125px;
  padding: 5px 0px;
`;

export const ChatSection = styled.div`
  position: relative;
  height: calc(100% - 2px);
  width: 100%;
`;

export const ChatInputSection = styled.div`
  position: absolute;
  bottom: 16px;
  left: 18px;
  right: 18px;
  height: 120px;
  width: calc(100% - 36px);
  background-color: white;
`;

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  max-width: 332px;
  text-align: center;
`;

export const ChatContainer = styled.div`
  background: #f6f8fb;
  overflow: hidden;
  height: 100vh;
`;

export const ConversationListContainer = styled.div`
  width: 16%;
  min-width: 236px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 8;
`;

export const ChatComponent = styled.div`
  width: calc(100vw - 236px);
  z-index: 9;
`;

export const ChatAndABVContainer = styled.div`
  height: 100%;
  min-width: 800px;
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
`;

export const ChatDetails = styled.div`
  width: 64.5%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ABVContainer = styled.div`
  width: 39.5%;
  border-left: 1px solid #edf0f7;
`;

export const VisitorBlockedIcon = styled.div`
  margin-left: 7px;
  > svg {
    display: block;
  }
`;

export const VisitorBlockedMessage = styled.span`
  display: inline-block;
  width: 456px;
  text-align: center;
  opacity: 1 !important;
  > span {
    font-weight: 600;
    color: #0061ff;
    cursor: pointer;
    opacity: 1;
  }
`;

export const FileDragAndDropContainer = styled.div`
  position: relative;
  div.dropzone-blur-effect {
    width: 100%;
    height: 100%;
    display: ${p => (p.isDragActive ? 'block' : 'none')};
    position: absolute;
    border: 1.4px dashed #0061ff;
    border-radius: 5px;
    background: radial-gradient(
      185.26% 3104.24% at 31.45% -40%,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0.01) 100%
    );
    box-shadow: 0px 3px 10px rgba(66, 82, 110, 0.2);
    backdrop-filter: blur(6px);
    z-index: 1;
  }
`;

export const AttachmentsPreviewContainer = styled.div`
  border-top: 1px solid #dbdee3;
  padding: 8px 18px 0;
  margin: 8px 0 -8px;
`;

export const ScrollIcon = styled.div`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: ${p => (p['data-position'] === 'left' ? '-10px' : 'initial')};
  right: ${p => (p['data-position'] === 'right' ? '-10px' : 'initial')};
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
  filter: drop-shadow(0px 0px 1px rgba(117, 133, 160, 0.31))
    drop-shadow(0px 3px 5px rgba(117, 133, 160, 0.2));
  img {
    display: block;
    width: 100%;
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-y: hidden;
  z-index: 1;
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  > div {
    width: 185px;
    margin-right: 8px;
  }
  > div:last-of-type {
    margin-right: 0;
  }
`;
